// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__f43E6","fullWidth":"FAQ_fullWidth__3k3q5","title":"FAQ_title__n8Ngw"};